import classNames from 'classnames';
import { type ReactNode, memo } from 'react';

import { UiKitCheckbox } from 'src/components/common/ui-kit-checkbox';
import { PolicyLink, RefundLink, TermsLink } from 'src/widgets/policy';

import { FormattedMessage } from '@features/intl';

import styles from './privacy-agreement.module.scss';

const DefaultAgreementText = () => (
  <FormattedMessage
    defaultMessage="By purchasing, you agree to our {privacy}, {terms}, and {subscription}"
    id="Onboarding.Paywall.Main.Terms"
    values={{
      privacy: <PolicyLink place="paywall" />,
      terms: <TermsLink place="paywall" />,
      subscription: <RefundLink place="paywall" />,
    }}
  />
);

export const PrivacyAgreement = memo(
  ({
    subscriptionAgreementChecked,
    setSubscriptionAgreementChecked,
    className,
    agreementText = <DefaultAgreementText />,
  }: {
    subscriptionAgreementChecked: boolean;
    setSubscriptionAgreementChecked: (checked: boolean) => void;
    agreementText?: ReactNode;
    className?: string;
  }) => {
    const randomId = 'subscriptionAgreement' + Math.random().toString();
    return (
      <div className={classNames(styles.subscriptionAgreement, className)}>
        <UiKitCheckbox
          checked={subscriptionAgreementChecked}
          label={agreementText}
          labelClassName={classNames(
            !subscriptionAgreementChecked && styles.dangerAgreement,
          )}
          value="subscriptionAgreement"
          onChange={() =>
            setSubscriptionAgreementChecked(!subscriptionAgreementChecked)
          }
          id={randomId}
        />
      </div>
    );
  },
);

PrivacyAgreement.displayName = 'PrivacyAgreement';
